import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=54f75f4e"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f75f4e')) {
      api.createRecord('54f75f4e', component.options)
    } else {
      api.reload('54f75f4e', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=54f75f4e", function () {
      api.rerender('54f75f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/LayoutHead/HeadNav/Link.vue"
export default component.exports